export default __webpack_public_path__ + "static/media/044-cargo-ship.7a51c43e.png";